import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getContainerStyles } from '../../../../utils/Utils';
import { ColorProps } from '../global/Helpers';
import ProductCarouselSliderContainer from './ProductCarouselSlider';

export default class ProductCarousel extends Component {
  render() {
    const {
      anchor,
      header,
      collections,
      products,
      history,
      align,
      columnWidths,
      backgroundColor,
      disableInfiniteSlider,
      type,
    } = this.props;
    const items = collections?.[0]?.productCollectionItems;

    return (
      <section
        id={anchor || undefined}
        className={classNames('product-carousel', type)}
        style={getContainerStyles(backgroundColor)}
      >
        <div className="product-carousel__inner-wrapper">
          {header ? (
            <div className={classNames('product-carousel__header', align?.toLowerCase() || 'center')}>
              <h2>{header}</h2>
            </div>
          ) : null}
          <ProductCarouselSliderContainer
            productCollectionItems={items}
            products={products}
            history={history}
            columnWidths={columnWidths}
            disableInfiniteSlider={disableInfiniteSlider}
          />
        </div>
      </section>
    );
  }
}

const productCollectionItemShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  item: PropTypes.object,
  sku: PropTypes.string,
});

const productCollectionShape = PropTypes.shape({
  productCollectionItems: PropTypes.arrayOf(productCollectionItemShape),
});

ProductCarousel.defaultProps = {
  align: 'center',
  products: [],
  productCollectionItems: [],
  header: 'Swipe some of our favorite designs',
  type: 'ProductCarousel',
};

ProductCarousel.propTypes = {
  align: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.string),
  collections: PropTypes.arrayOf(productCollectionShape),
  history: PropTypes.object,
  header: PropTypes.string,
  backgroundColor: ColorProps,
  type: PropTypes.string,
};
